import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';

export default function ClientNav() {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 h-16 glass-card border-b border-border">
      <div className="max-w-screen-2xl mx-auto px-6 h-full flex items-center justify-between">
        <Link href="/" className="flex items-center gap-2.5">
          <AppLogo size={32} />
          <span className="font-bold text-lg tracking-tight text-foreground">
            Precision Surface & Detail <span className="gold-text">Booking</span>
          </span>
        </Link>
        <nav className="hidden md:flex items-center gap-6">
          <Link href="/" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
            Services
          </Link>
          <Link href="/#service-conditions" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
            Fees & Conditions
          </Link>
          <Link href="/faq" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
            FAQ
          </Link>
          <Link href="/booking-flow" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
            Book Now
          </Link>
          <Link href="/my-bookings" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
            My Bookings
          </Link>
          <Link href="/admin-dashboard" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
            Admin
          </Link>
        </nav>
        <div className="flex items-center gap-3">
          <Link
            href="/booking-flow"
            className="hidden md:inline-flex items-center gap-2 px-4 py-2 rounded-lg gold-gradient text-primary-foreground text-sm font-semibold transition-all duration-150 hover:opacity-90 active:scale-95"
          >
            Book Now
          </Link>
        </div>
      </div>
    </header>
  );
}